import { ButtonGroup, CircularProgress, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import GetAppIcon from "@material-ui/icons/GetApp";

interface Props {
	deleteItem?: () => void;
	editItem?: () => void;
	downloadItem?: () => void;
	loading?: boolean;
	deleteLabel?: string;
	editLabel?: string;
	downloadLabel?: string;
}

export const AgGridButtons = ({
	deleteItem,
	editItem,
	downloadItem,
	downloadLabel,
	deleteLabel,
	editLabel,
	loading,
}: Props) => {
	return (
		<>
			<ButtonGroup>
				{editItem && (
					<IconButton
						color={"primary"}
						onClick={() => {
							editItem();
						}}
						title={editLabel || "Edit"}
					>
						<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
					</IconButton>
				)}
				{deleteItem && (
					<IconButton
						color={"secondary"}
						onClick={() => {
							deleteItem();
						}}
						title={deleteLabel || "Delete"}
					>
						<DeleteIcon style={{ cursor: "pointer" }} fontSize="small" />
					</IconButton>
				)}
				{downloadItem && (
					<IconButton
						color={"primary"}
						onClick={() => {
							downloadItem();
						}}
						title={downloadLabel || "Get data"}
						disabled={loading}
					>
						<GetAppIcon style={{ cursor: "pointer" }} fontSize="small" />
						{loading && <CircularProgress size={16} color="inherit" />}
					</IconButton>
				)}
			</ButtonGroup>
		</>
	);
};
